import { render, staticRenderFns } from "./role-tree.vue?vue&type=template&id=a65c39f0&scoped=true&"
import script from "./role-tree.vue?vue&type=script&lang=tsx&"
export * from "./role-tree.vue?vue&type=script&lang=tsx&"
import style0 from "./role-tree.vue?vue&type=style&index=0&id=a65c39f0&prod&lang=scss&scoped=true&"
import style1 from "./role-tree.vue?vue&type=style&index=1&id=a65c39f0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65c39f0",
  null
  
)

export default component.exports